class PublicKeysController {
    constructor($uibModal, $window, $routeParams, $location, $browser, Upload, UtpSimServiceApi, toastr) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.state = this.resolve.params;
            if (this.resolve.params === undefined) {
                this.state = this.resolve;
            }
        };
        this.downloadOwnKey = (publicKeyId) => {
            let url = ['api/download/PublicKeyFile?Id=', publicKeyId].join('');
            this.window.location.href = url;
            return;
        };
        this.downloadPublicKey = () => {
            let url = 'api/download/PublicDownloadKeyFile';
            this.window.location.href = url;
            return;
        };
        this.checkFileSizes = (files) => {
            let fac = {
                tooLarge: []
            };
            let maxFileSize = this.state.appSettings.MaxUploadMb;
            angular.forEach(files, function (file) {
                let fileSizeMb = file.size / 1048576;
                if (fileSizeMb > maxFileSize) {
                    fac.tooLarge.push(file);
                }
            });
            return fac;
        };
        this.checkFileExtensions = (files) => {
            let fac = {
                invalidExtension: []
            };
            if (!this.state.appSettings.CertUploadExtensions || this.state.appSettings.CertUploadExtensions === '') {
                return false;
            }
            let extArray = this.state.appSettings.CertUploadExtensions.split(',');
            angular.forEach(files, function (file) {
                // Get the file extension
                let arr = file.name.split('.');
                let validExtension = false;
                if (arr.length > 1) {
                    // Get the extension last part of split length - 1
                    let extension = arr[arr.length - 1];
                    for (let i = 0; i < extArray.length; i++) {
                        if (extArray[i].toLowerCase() === extension.toLowerCase()) {
                            validExtension = true;
                            break;
                        }
                    }
                }
                if (!validExtension) {
                    fac.invalidExtension.push(file);
                }
            });
            return fac;
        };
        this.uploadPublicKey = (files) => {
            let fsCheck = this.checkFileSizes(files);
            let toastr = this.toastr;
            if (fsCheck.tooLarge.length > 0) {
                angular.forEach(fsCheck.tooLarge, function (file) {
                    toastr.warning(file.name + ' is too large.');
                });
                return;
            }
            let extCheck = this.checkFileExtensions(files);
            let validFileExtensions = this.state.appSettings.CertUploadExtensions;
            if (extCheck.invalidExtension.length > 0) {
                angular.forEach(extCheck.invalidExtension, function (file) {
                    toastr.warning('This is an invalid file to upload.  You can only upload files with extension(s):'
                        + validFileExtensions + '.');
                });
                return;
            }
            this.UtpSimServiceApi.isSimulatorRunning(this.state.user.Id, this.state.selectedSim.SimulatorId).then((response) => {
                let isSimUp = response.data;
                if (isSimUp) {
                    this.toastr.warning('Simulator is current running, Certificates cannot be uploaded');
                }
                else {
                    let requestDto;
                    if (files.length > 0) {
                        requestDto = {
                            SimId: this.state.selectedSim.SimulatorId,
                            UserId: this.state.user.Id,
                            Files: files
                        };
                        this.Upload.upload({
                            method: 'post',
                            url: 'api/ManageSimulator/PublicKeyUpload',
                            data: requestDto
                        }).then((response) => {
                            if (response.status === 200) {
                                let keySaveResult = response.data;
                                if (keySaveResult.errors.length !== 0) {
                                    angular.forEach(keySaveResult.errors, (validationError) => {
                                        this.toastr.error(validationError);
                                    });
                                }
                                else {
                                    this.toastr.info('Public Key Uploaded');
                                    this.state.selectedSim.PublicKeyFilename = files[0].name;
                                    this.state.selectedSim.PublicKeyId = keySaveResult.PublicKeyId;
                                }
                            }
                        });
                    }
                }
            });
        };
        this.cancel = () => {
            this.close();
        };
        this.window = $window;
        this.browser = $browser;
        this.uibModal = $uibModal;
        this.toastr = toastr;
        this.location = $location;
        this.Upload = Upload;
        this.UtpSimServiceApi = UtpSimServiceApi;
    }
}
angular.module('app').component('publicKeys', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/PublicKeys/public-keys.tpl.html',
    controllerAs: 'vm',
    controller: PublicKeysController
});
